const EMAIL_REGEX: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const validateEmail = (emailValue: unknown): emailValue is string => {
  if (typeof emailValue !== 'string') {
    return false
  }

  return EMAIL_REGEX.test(emailValue)
}
